import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDownloadURLForSpocsWithFiltersRPC } from "./getPresignedDownloadUrlForSpocsWithFiltersRPC";

export class GetPresignedDownloadURLForSpocsWithFiltersRPCClientImpl extends GetPresignedDownloadURLForSpocsWithFiltersRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDownloadURLForSpocsWithFiltersRPC.Request): Promise<LeoRPCResult<GetPresignedDownloadURLForSpocsWithFiltersRPC.Response, GetPresignedDownloadURLForSpocsWithFiltersRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/GetPresignedDownloadURLForSpocsWithFilters",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDownloadURLForSpocsWithFiltersRPC.ResponseDTO,
      GetPresignedDownloadURLForSpocsWithFiltersRPC.Errors.ErrorsDTO,
      GetPresignedDownloadURLForSpocsWithFiltersRPC.Response,
      GetPresignedDownloadURLForSpocsWithFiltersRPC.Errors.Errors
    >(
      response,
      "spoc-management/GetPresignedDownloadURLForSpocsWithFilters",
      GetPresignedDownloadURLForSpocsWithFiltersRPC.Response.fromDTO,
      GetPresignedDownloadURLForSpocsWithFiltersRPC.Errors.fromDTO
    );
  }
}
